module.exports = __webpack_public_path__ + "static/media/junte-troque-modal-mobile.4714a4c7.png";